// src/components/reports/CapacityGauge.tsx — semicircle "% sold" gauge,
// hand-drawn SVG (dependency-free). Sage >= 75%, brass >= 50%, else signal.
// Ported from the prototype.

import { C, F } from "../../theme";

export const CapacityGauge = ({ value, size = 150 }: { value: number; size?: number }) => {
  const r = size / 2 - 10;
  const cx = size / 2;
  const cy = size / 2 + 6;
  const circ = Math.PI * r; // semicircle length
  const dash = Math.max(0, Math.min(1, value)) * circ;
  const arc = (rr: number) => `M ${cx - rr} ${cy} A ${rr} ${rr} 0 0 1 ${cx + rr} ${cy}`;
  const col = value >= 0.75 ? C.sageDk : value >= 0.5 ? C.brassDk : C.signalDk;
  return (
    <svg viewBox={`0 0 ${size} ${cy + 6}`} width="100%" style={{ display: "block", maxWidth: size }}>
      <path d={arc(r)} fill="none" stroke={C.paperWarm} strokeWidth="12" strokeLinecap="round" />
      <path d={arc(r)} fill="none" stroke={col} strokeWidth="12" strokeLinecap="round" strokeDasharray={`${dash} ${circ}`} />
      <text x={cx} y={cy - 8} textAnchor="middle" fontFamily={F.serif} fontSize="30" fontWeight="700" fill={C.ink}>
        {Math.round(value * 100)}%
      </text>
      <text x={cx} y={cy + 6} textAnchor="middle" fontFamily={F.body} fontSize="10" fontWeight="800" fill={C.inkMute} letterSpacing="0.5">
        SOLD
      </text>
    </svg>
  );
};
